module.exports = __webpack_public_path__ + "static/media/sloganChi.ceab085d.png";